import { CalendarDaysIcon, MapIcon, UsersIcon } from 'lucide-preact';
import { ComponentProps, FunctionalComponent } from 'preact';
import { getCurrentUrl } from 'preact-router';
import { useDispatch } from 'react-redux';

import { HighlightIcon } from '@/components/icons';
import { setMembersOnlyWarningModalState } from '@/components/MembersOnlyWarningModal/redux/actions';
import { isEmbedded, loadPage } from '@/helpers';
import { useSelector } from '@/redux/helper';

import style from './style.scss';

const activeClass = (path: string) => (getCurrentUrl().includes(path) ? style.active : undefined);

const MobileTabs: FunctionalComponent = () => {
  const dispatch = useDispatch();
  const logged = useSelector((state) => state.user.logged);
  const onClickTabHandler: ComponentProps<'a'>['onClick'] | undefined = isEmbedded()
    ? (e) => {
        e.preventDefault();
        loadPage(e.currentTarget.href);
      }
    : undefined;
  const dataNative = onClickTabHandler ? 'true' : undefined;

  return (
    <nav className={style.mobileTabs}>
      <ul>
        <li>
          <a data-native={dataNative} className={activeClass('/highlights')} href="/highlights" onClick={onClickTabHandler}>
            <HighlightIcon className="size-[1em]" />
            <span className="sr-only">Highlights</span>
          </a>
        </li>
        <li>
          <a data-native={dataNative} className={activeClass('/home')} href="/home" onClick={onClickTabHandler}>
            <MapIcon className="size-[1em]" />
            <span className="sr-only">Habitats</span>
          </a>
        </li>
        <li>
          <a
            data-native={logged ? dataNative : true}
            href="/feed"
            className={activeClass('/feed')}
            onClick={(e) => {
              if (logged) {
                onClickTabHandler?.(e);
              } else {
                e.preventDefault();
                dispatch(setMembersOnlyWarningModalState({ type: 'guest-general' }));
              }
            }}
          >
            <UsersIcon className="size-6" />
            <span className="sr-only">Community Feed</span>
          </a>
        </li>
        <li>
          <a data-native={dataNative} className={activeClass('schedule')} href="/schedule" onClick={onClickTabHandler}>
            <div className="relative">
              <CalendarDaysIcon className="size-[1em]" />
              <span className="sr-only">Schedule</span>
            </div>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default MobileTabs;
